enum VehicleType {
	Resident,
	Visitor,
	Temporary
}

export default VehicleType;
